var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"first_index"},[_c('el-row',{attrs:{"gutter":24}},[_c('el-col',{attrs:{"span":24}},[_c('Homepage')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }